export const LIMIT_BLOG_CARDS = 6;
